import qs from 'qs'
import axios from '../index'

export function getLocations(params) {
  return axios.get('/ajax/clients/locations', { params })
}

export function getLocation(params) {
  return axios.get(`/ajax/clients/locations/${params.id}`)
}

export function getLocationsForSelect(params) {
  return axios.get('/ajax/clients/locations/for_select', { params })
}

export function createLocation(params) {
  return axios.post('/ajax/clients/locations', params)
}

export function updateLocation(id, params) {
  return axios.patch(`/ajax/clients/locations/${id}`, params)
}

export function syncProvider(params) {
  return axios.post('/ajax/clients/locations/sync', params)
}

export function getAvailableLocationKeys() {
  return axios.get('/ajax/clients/api_keys')
}

export function searchGooglePlaces(params) {
  return axios.get('/ajax/clients/locations/search', { params })
}

export function fetchGooglePlaceByMapUrl(params) {
  return axios.get('/ajax/clients/locations/fetch_by_url', { params })
}

export function getCountries() {
  return axios.get('/ajax/clients/locations/countries')
}

export function getCategories() {
  return axios.get('/ajax/clients/locations/categories')
}

export function getA1LocationWebsitePages(locationId) {
  return axios.get(`/ajax/clients/a1/locations/${locationId}/website_pages`)
}

export function associateWebsitePage(locationId, websitePageId) {
  return axios.post(`/ajax/clients/a1/locations/${locationId}/website_pages/${websitePageId}/associate`)
}

export function disassociateWebsitePage(locationId, websitePageId) {
  return axios.delete(`/ajax/clients/a1/locations/${locationId}/website_pages/${websitePageId}/disassociate`)
}

export function getJobsForLocation(locationId, dateRange = {}) {
  return axios.get('/ajax/clients/a1/jobs', {
    params: {
      location_id: locationId,
      start_date: dateRange.start_date,
      end_date: dateRange.end_date
    }
  })
}

export function exportJobsForLocation(params) {
  return axios.get('/ajax/clients/a1/jobs/export', {
    params,
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'brackets' }),
    responseType: 'blob'
  })
}
